import { atom } from "recoil";

import { IDashboardDto } from "../../dto";

export const dashboardDtoAtom = atom<IDashboardDto | undefined>({
  key: "dashboardDtoAtom",
  default: undefined,
});

export const dashboardErrorsAtom = atom<string[] | undefined>({
  key: "dashboardErrorsAtom",
  default: undefined,
});
